import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { RoomType, RoomTypeSelection } from "../../../Models";
import { getValueByLang } from "../../../Utils";

export default function RoomTypeSelectionComponent(): m.Component<{
    roomTypeSelection: RoomTypeSelection,
    messageProvider: MessageProvider,
}> {   
    return {
        view(vnode) { 
            const { roomTypeSelection, messageProvider } = vnode.attrs;
            const roomType: RoomType = roomTypeSelection.roomType;
            const roomTypeName = getValueByLang(roomType.name, messageProvider.getCurrentLang());
            const maxOccupancy = roomTypeSelection.numberOfAdults; //TODO refactor
            const numberOfNights = roomTypeSelection.ratePerNights.length;
                 
            const subtotalAmount = roomTypeSelection.ratePerNights
                .map(it => it.sellRate)
                .reduce((aggregate: number, amount: number) => aggregate + amount, 0);

            let discountAmount = 0;
            roomTypeSelection.ratePerNights.forEach(it => {
                if(it.discountApplied != null){
                    discountAmount += it.discountApplied.amount.numericValue;
                }
            })    

            return m("div", {}, [
                m("div.row no-gutters mb-2", [
                    m("div.col-4",
                        m("img.card-img w-100 h-100 rounded-16", {src: roomType.featuredPhotoUrl})
                    ),
                    m("div.col-8 pl-2", [
                        m("div.d-flex", [
                            m("div.w-100", { class: "ml-2" }, m("strong", { class: "room-name-color" }, roomTypeName))                      
                        ]),
                        m("div", { class: "ml-2 mb-2" }, 
                            m("div.row py-1", [
                                m("div.col col-auto",
                                    m("small",  messageProvider.get("stay") + " - ")
                                ),
                                m("div.col pl-0", [
                                    m("small", messageProvider.interpolate("number_of_adults", {count:maxOccupancy})),

                                    (roomType.maxChildAge > 0)? 
                                    [
                                        m("small",  ((messageProvider.getCurrentLang() == "en")?", ": "၊ ") + messageProvider.interpolate("number_of_child", {count:1})),
                                    ]:null
                                ])
                            ]),

                            (roomTypeSelection.numberOfExtraBeds > 0)? 
                            m("div.pb-1", 
                                m("small", {}, messageProvider.get("extra_bed") + " - " + roomTypeSelection.numberOfExtraBeds + " " + messageProvider.get("included"))
                            ):null,
                    
                            m("div.row", [
                                m("div.col col-auto", [
                                    m("small", messageProvider.interpolate("for_nights", {nights:numberOfNights}) + " - ")
                                ]),
                                m("div.col pl-0", [
                                    m("small", { class: "font-weight-bold text-dark" }, new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(subtotalAmount) + " MMK"),
                                    (discountAmount > 0 && roomTypeSelection.numberOfExtraBeds > 0)? 
                                    m("small.text-muted", " ( " + messageProvider.get("discount_applied_and_extra_bed_included") + " )"): null,
                                    
                                    (discountAmount > 0 && roomTypeSelection.numberOfExtraBeds == 0)? 
                                    m("small.text-muted", " ( " + messageProvider.get("discount_applied") + " )"):null,

                                    (discountAmount == 0 && roomTypeSelection.numberOfExtraBeds > 0)?
                                    m("small.text-muted", " ( " + messageProvider.get("extra_bed_included") + " )"):null,
                                ]) 
                            ])
                        )
                    ])
                ]),
                (roomTypeSelection.valueAddedPromotion != null)?
                m("div", [
                    m("div.d-flex align-items-center", [
                        m("div", m("i.fas fa-gift pr-1 text-success")),
                        m("div", m("small.font-weight-bold text-dark", getValueByLang(roomTypeSelection.valueAddedPromotion.fullMessage, messageProvider.getCurrentLang())))
                    ])
                ]):null,            
            ])
        }
    }
}